// src/lib/supabase.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://cvqsfamvxgbwtjwukptq.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN2cXNmYW12eGdid3Rqd3VrcHRxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjEzOTY0NDcsImV4cCI6MjA3Njk3MjQ0N30.9WvyZYr_YxBUSW37Z6H1Fh4zRpYbPidWP6j9Bb08g8k';

// Create and export the Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Optional: Add helper functions
export const getCurrentSession = async () => {
  const { data: { session }, error } = await supabase.auth.getSession();
  if (error) throw error;
  return session;
};

export const getCurrentUser = async () => {
  const { data: { user }, error } = await supabase.auth.getUser();
  if (error) throw error;
  return user;
};